<template>
  <div class="grid grid-cols-12 gap-y-8 md:gap-x-4">
    <div class="col-span-12 md:col-span-4" :key="columnIndex" v-for="(item, columnIndex) in columns">
      <h4 class="mb-2">{{ item.title }}</h4>
      <p v-if="item.explanation" class="mb-4">{{ item.explanation }}</p>

      <ul class="shortcut-list">
        <li :key="shortcutIndex" v-for="(shortcut, shortcutIndex) in item.shortcuts">
          <base-shortcut class="p-0" v-bind="shortcut" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShortcutsModal',

  computed: {
    columns () {
      return [{
        title: this.$i18n.t('shortcuts.navigation'),
        explanation: this.$i18n.t('shortcuts.generalNavigationExplanation'),
        shortcuts: [{
          title: this.$i18n.t('shortcuts.highlightItem'),
          combinations: [{ content: '↹' }]
        }, {
          title: this.$i18n.t('shortcuts.previousRow'),
          combinations: [{ icon: ['fal', 'arrow-alt-up'] }, { icon: ['fal', 'arrow-up'] }]
        }, {
          title: this.$i18n.t('shortcuts.nextRow'),
          combinations: [{ icon: ['fal', 'arrow-alt-up'] }, { icon: ['fal', 'arrow-down'] }]
        }, {
          title: this.$i18n.t('shortcuts.enterItem'),
          combinations: [{ content: '↵' }]
        }, {
          title: this.$i18n.t('shortcuts.closeModalWindow'),
          combinations: [{ content: this.$i18n.t('shortcuts.escape') }]
        }]
      }, {
        title: this.$i18n.t('shortcuts.tabsNavigation'),
        explanation: this.$i18n.t('shortcuts.tabsNavigationExplanation'),
        shortcuts: [{
          title: this.$i18n.t('shortcuts.firstTab'),
          combinations: [{ icon: ['fal', 'arrow-alt-up'] }, { content: '1' }]
        }, {
          title: this.$i18n.t('shortcuts.secondTab'),
          combinations: [{ icon: ['fal', 'arrow-alt-up'] }, { content: '2' }]
        }]
      }, {
        title: this.$i18n.t('shortcuts.hotkeys'),
        explanation: this.$i18n.t('shortcuts.hotKeysExplanation'),
        shortcuts: [{
          title: this.$i18n.t('shortcuts.focusSearch'),
          combinations: [{ content: '/' }]
        }, {
          title: this.$i18n.t('shortcuts.shortcuts'),
          combinations: [{ content: '?' }]
        }, {
          title: this.$i18n.t('shortcuts.changeDateTime'),
          combinations: [{ icon: ['fal', 'arrow-alt-up'] }, { content: 'D' }]
        }, {
          title: this.$i18n.t('shortcuts.accessFilters'),
          combinations: [{ icon: ['fal', 'arrow-alt-up'] }, { content: 'F' }]
        }, {
          title: this.$i18n.t('shortcuts.accessExport'),
          combinations: [{ icon: ['fal', 'arrow-alt-up'] }, { content: 'X' }]
        }, {
          title: this.$i18n.t('shortcuts.accessColumns'),
          combinations: [{ icon: ['fal', 'arrow-alt-up'] }, { content: 'C' }]
        }, {
          title: this.$i18n.t('shortcuts.editMode'),
          combinations: [{ icon: ['fal', 'arrow-alt-up'] }, { content: 'E' }]
        }, {
          title: this.$i18n.t('shortcuts.addNewItem'),
          combinations: [{ icon: ['fal', 'arrow-alt-up'] }, { content: 'N' }]
        }]
      }]
    }
  }
}
</script>

<style lang="postcss" scoped>
  .shortcut-list {
    > li {
      @apply flex items-start;

      + li {
        @apply mt-2;
      }
    }
  }
</style>
